import Mbs from './Mbs';

export default Mbs;
